// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.database-list-CYqvaW{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.default-text-B1rnSq{color:rgba(28,29,35,.6);font-size:14px;font-weight:400;line-height:22px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"database-list": `database-list-CYqvaW`,
	"databaseList": `database-list-CYqvaW`,
	"default-text": `default-text-B1rnSq`,
	"defaultText": `default-text-B1rnSq`
};
export default ___CSS_LOADER_EXPORT___;
